export default "__VITE_ASSET__DrGzyT6y__"